import Model from 'flarum/common/Model';

/**
 * v0.17.31 — 课次的前端 model
 *
 * ## 为什么必须存在
 *   后端 `LessonResource` 注册的 JSON:API 类型名是 `schedulerLessons`
 *   (见 src/Api/Resource/LessonResource.php)。通知列表的响应里会带上
 *   `relationships.subject.data = { type: 'schedulerLessons', id: '…' }`,
 *   前端 mithril Store.pushObject() 会拿 `data.type` 去 `app.store.models` 里查模型类:
 *
 *     vendor/flarum/core/js/src/common/Store.ts:136
 *       if (!this.models[data.type]) {
 *         setTimeout(() => { throw new Error(`Pushing object of type ... not registered in the store.`); });
 *         return null;
 *       }
 *
 *   不注册 ⇒ 抛 "Pushing object of type `schedulerLessons` not allowed" ⇒
 *   整批通知入 store 失败 ⇒ **铃铛里看不到任何新通知**。
 *   实测: 只做后端注册时, 接口 200、库里也有行、铃铛里就是没有。
 *   后端 API Resource 与前端 store model 是**成对**的, 少一半就不显示。
 *
 * ## 为什么字段可以全空
 *   铃铛文案只用通知自带的 `content` (coachName / studentName / startAt …),
 *   不读 subject 的属性。所以这里不需要任何 attribute 映射, 只要一个类存在、
 *   能让 store 认出这个类型即可。
 */
export default class Lesson extends Model {}
flarum.reg.add('ziiven-ziven-scheduler', 'forum/models/Lesson', Lesson);